module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch3_20210921104149_T.521c85ce.jpg";